import { render, staticRenderFns } from "./CustomHomeIndex.vue?vue&type=template&id=12ea3d7f"
import script from "@/controllers/custom-home-index.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom-home-index.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports